import styled from 'styled-components';

const LeaderboardItemEmail = styled.h4``;

export default LeaderboardItemEmail;
